export default __webpack_public_path__ + "static/arweave-7ca6a888888852efb1ea15070a2fb1c3.svg";